import { ExpandMore, PropaneSharp } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Paper } from "@mui/material";
import { Stack } from "@mui/system";
import { FieldLabel, FieldLabelDecLong, FieldLabelDecShort } from "./FieldLabel";

type PFieldContainer = {
    label: string;
    dec_short?: string;
    dec_long?: string;
    children: any;
};

export default function FieldContainer(props: PFieldContainer) {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction={"column"} spacing={0}>
                    <Stack direction={"row"} spacing={1}>
                        <FieldLabel>{props.label}</FieldLabel>
                        <FieldLabelDecShort>{props.dec_short}</FieldLabelDecShort>
                    </Stack>
                    <FieldLabelDecLong>{props.dec_long}</FieldLabelDecLong>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </Accordion>
    );
}
